import React from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { BreadcrumbContainer } from './Breadcrumb.styled';
import DynamicBreadcrumbs from '../../../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs';
import { usePromptTitle } from '../../hooks/usePromptTitle';   

const Breadcrumb = ({ promptNameFromParent = '' }) => {
  const { promptId } = useParams();          
  const { pathname } = useLocation();

  const title = usePromptTitle(promptId, promptNameFromParent);


  const items = [
    { label: 'Prompt Management', href: '/v2/pms' },
  ];

  if (pathname.includes('/config')) {
    items.push({
      label: title,
      href: `/v2/pms/config/${promptId ?? 'new'}`,
    });
  }

  if (pathname.endsWith('/versions')) {
    items.push({ label: 'Versions', href: pathname });
  }

  return (
    <BreadcrumbContainer>
      <DynamicBreadcrumbs items={items} currentPath={pathname} />
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;
